import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonResponsiveWrapper, useResponsive } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';
import { PendingModal } from '@/components/elements';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
  header?: string;
  submitButtonTitle?: string;
}
const ConfirmCancelModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onSubmit,
  header,
  submitButtonTitle,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit();
    onSetVisible(false);
  };
  return (
    <PendingModal
      header={header || t('Cancel reimbursement?')}
      visible={visible}
      onSetVisible={onSetVisible}
      onSubmit={onSubmit}
      testId="confirm-cancel-modal"
    >
      <ButtonResponsiveWrapper fill={isMobile} margin={{ top: 'spacing24' }}>
        <AppButton
          testId="confirm-cancel"
          fill={isMobile}
          onClick={() => onSetVisible(false)}
          buttonType="secondary"
          width="130px"
        >
          {t('Cancel')}
        </AppButton>
        <AppButton fill={isMobile} onClick={handleSubmit} color="red" testId="confirm-submit">
          {submitButtonTitle || t('Yes, Cancel Reimbursement')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </PendingModal>
  );
};

export default ConfirmCancelModal;
